import { createContext, useContext } from 'react'

export const ReasonPresetInspectionContext = createContext(null)

export const useReasonPresetInspection = () =>
    useContext(ReasonPresetInspectionContext)
